import { ref } from "vue"
import { i18n, getPathLocale } from '@/translations/i18n'
import { AdyenCheckout } from "@adyen/adyen-web"
import { showSnackbar } from "@/helper"
import { getProceedResponseRedirect, isProceedErrorRedirectUrl } from '@/composables/usePayment'

let instance = ref(null)
export const isAdyenValid = ref(true)
export const adyenHasInput = ref(false)
export const formSubmitPressed = ref(false)

export function getAdyen() {
  return instance
}

export function resetAdyenErrors() {
  isAdyenValid.value = true
  adyenHasInput.value = false
}

export function setAdyenValid(value) {
  isAdyenValid.value = value
}

export function setAdyenHasInput(value) {
  adyenHasInput.value = value
}

export function setFormSubmitPressed(value) {
  formSubmitPressed.value = value
}

export async function initAdyen(config) {
  if (!instance.value) {
    instance.value = await AdyenCheckout(config)
  }

  return instance.value
}

export async function handleAdditionalDetails(state, component) {
  try {
    const csrfParam = document
      .querySelector('meta[name="csrf-param"]')
      ?.getAttribute("content")

    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content")

    const body = {
      ...state.data,
      [csrfParam]: csrfToken,
    }

    const res = await fetch(
      `/${getPathLocale()}/checkout/additional_details`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify(body),
      }
    )

    if (!res.ok) {
      throw new Error("Network response was not ok")
    }

    const response = await res.json()

    const refusedCodes = ['Refused', 'Cancelled', 'Error']
    const isRefused = response?.result?.resultCode && refusedCodes.includes(response.result.resultCode)
    const redirectUrl = getProceedResponseRedirect(response)
    const errRedirect = Boolean(redirectUrl && isProceedErrorRedirectUrl(redirectUrl))
    const shouldRedirect = Boolean(redirectUrl && !isRefused && !errRedirect)

    if (shouldRedirect) {
      window.location.href = redirectUrl
    } else if (errRedirect) {
      const msg =
        i18n.global?.t?.('messages.checkout.purchase.payment_refused') ||
        i18n.global?.t?.('messages.page.revocation.error') ||
        'Payment could not be completed.'
      showSnackbar('error', 'iconfont-info', msg)
    } else if (isRefused && response?.result?.resultCode === 'Refused') {
      const msg = i18n.global?.t?.('messages.checkout.purchase.payment_refused') || 'Payment was refused. Please check your card details and try again.'
      showSnackbar('error', 'iconfont-info', msg)
    }

  } catch {
  }
}
